import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, Spinner } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, CardHeader, Button } from 'reactstrap';
import axios from 'axios';
import config from '../../../../../config';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import ReactApexChart from 'react-apexcharts';
import configDB from '../../../../../Config/ThemeConfig';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ApexCharts from 'apexcharts';

const DATE_FILTERS = [
  //{ label: 'TODAY', value: 'today' },
  { label: 'PREVIOUS DAY', value: 'previous_day' },
  { label: 'THIS WEEK', value: 'this_week' },
  { label: 'PREVIOUS WEEK', value: 'previous_week' },
  { label: 'THIS MONTH', value: 'this_month' },
  { label: 'PREVIOUS MONTH', value: 'previous_month' },
];


const TimeSeriesTrendChartFromInvoiceView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const primary = localStorage.getItem('default_color') || configDB.data.color.primary_color;
    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [groups, setGroups] = useState([]);
    const [allSubcategories, setAllSubcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [loading, setLoading] = useState(false);

    const [activeDateFilter, setActiveDateFilter] = useState('previous_day');
    const [chartData, setChartData] = useState(Array(24).fill(0));

    const [tooltip, setTooltip] = useState('');

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [selectedTenants, setSelectedTenants] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');
    const [totalNetSales, setTotalNetSales] = useState(0);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const hours = Array.from({ length: 24 }, (_, i) => i.toString());
    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    // 🔽 Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getgroupnames`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setGroups(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/category/getcategorybyconcessionaire`, { category_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/subcategory/getsubcategorybyconcessionaire`, { subcategory_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setAllSubcategories(response.data);
                setSubcategories(response.data); // Initial set to all subcategories
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        let filteredSubcategories = allSubcategories;

        if (category_id !== '') {
            filteredSubcategories = filteredSubcategories.filter(subcategory => subcategory.category_id._id === category_id);
        }

        setSubcategories(filteredSubcategories);
    }, [category_id]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);


    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_store_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });


    const fetchChartData = async (date_filter) => {
        setLoading(true);
        setActiveDateFilter(date_filter);

        try {
            const category_name = category_id !== '' ? categories.find(category => category._id === category_id).category_name : '';
            const property_name = property_id !== '' ? properties.find(property => property._id === property_id).property_name : '';
            const subcategory_name = subcategory_id !== '' ? subcategories.find(subcategory => subcategory._id === subcategory_id).subcategory_name : '';
            const tenant_name = tenant_id !== '' ? tenants.find(tenant => tenant._id === tenant_id).tenant_store_name : '';

        const res = await axios.post(
            `${config.hostname}/reports/gettimeseriestrendchartfrominvoice`,
            {
            concessionaire_id,
            date_filter,
            group_name,
            category_name,
            property_name,
            subcategory_name,
            tenant_id: selectedTenants
            },
            configheader
        );

        setChartData(res.data?.lineOptions?.netSales?.data || Array(24).fill(0));
        setTotalNetSales(res.data?.totalNetSales || 0);
        setStartDate(res.data?.start_date || '');
        setEndDate(res.data?.end_date || '');
        } catch (err) {
        console.error(err);
        toast.error('Error');
        } finally {
        setLoading(false);
        }
    };

    useEffect(() => {
        fetchChartData(activeDateFilter);
    }, [
    property_id,
    category_id,
    subcategory_id,
    group_name,
    selectedTenants
    ]);

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }

    /* ---------------- CHART OPTIONS ---------------- */

    const chartOptions = {
        series: [{ name: 'Net Sales', data: chartData }],
        chart: { id: 'netSalesChart', type: 'line', height: 350, toolbar: { show: false } },
        stroke: { curve: 'smooth', width: 3 },
        xaxis: { categories: hours, title: { text: 'Hour' }, tooltip: { enabled: false } },
        yaxis: { title: { text: 'Net Sales' } },
        colors: [primary],
        dataLabels: { enabled: false },
        tooltip: { x: {
                formatter: (val) => {
                const hour = Number(val);
                return `${hour-1}-${hour} Hr`;
                }
            },
            y: { formatter: (val) => val.toFixed(2)}
        }
    };

    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setTenantId('');
        setSelectedTenants([]);
    };

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('');
        setSelectedTenants([]);
    };

    const handleCategoryChange = (e) => {
        setCategoryId(e.target.value);
        setSubcategoryId('')
        setTenantId('');
        setSelectedTenants([]);
    };

    const handleSubCategoryChange = (e) => {
        setSubcategoryId(e.target.value);
        setTenantId('')
        setSelectedTenants([]);
    };

    const handleTenantChange = (e) => {
        const { value, checked } = e.target;

        setSelectedTenants((prev) => {
            if (checked) {
                // Add if not already there
                if (prev.includes(value)) return prev;
                return [...prev, value];
            } else {
                // Remove if unchecked
                return prev.filter((item) => item !== value);
            }
        });
    };

    const getFilterLabel = (value) => {
    const map = {
        previous_day: 'Previous Day',
        this_week: 'This Week',
        previous_week: 'Previous Week',
        this_month: 'This Month',
        previous_month: 'Previous Month'
    };
    return map[value] || value;
    };


    const exportChartToExcel = async () => {
        try {
            // ✅ Get chart image from ApexCharts core
            const chartResult = await ApexCharts.exec(
            'netSalesChart',
            'dataURI'
            );

            if (!chartResult || !chartResult.imgURI) {
            toast.error('Chart not ready yet');
            return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Net Sales Trend');

            // 🔹 Header
            worksheet.mergeCells('A1:J1');
            worksheet.getCell('A1').value = 'Net Sales Trend Report';
            worksheet.getCell('A1').font = { size: 16, bold: true };

            worksheet.addRow([]);
            worksheet.addRow(['Period', `${startDate} – ${endDate}`]);
            worksheet.addRow(['Total Net Sales', `${totalNetSales.toFixed(2)}`]);
            worksheet.addRow(['Property', property_id ? properties.find(p => p._id === property_id)?.property_name : 'All']);
            worksheet.addRow(['Category', category_id ? categories.find(c => c._id === category_id)?.category_name : 'All']);
            worksheet.addRow(['Subcategory', subcategory_id ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name : 'All']);
            worksheet.addRow(['Group', group_name || 'All']);
            worksheet.addRow(['Exported By', login_name]);
            worksheet.addRow(['Exported On', new Date().toLocaleString()]);
            worksheet.addRow([]);

            // 🔹 Add chart image
            const imageId = workbook.addImage({
            base64: chartResult.imgURI,
            extension: 'png',
            });

            worksheet.addImage(imageId, {
            tl: { col: 0, row: 12 },
            ext: { width: 900, height: 420 },
            });

            // 🔹 Export
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(
            new Blob([buffer]),
            `Net_Sales_Trend_${getFilterLabel(activeDateFilter)}.xlsx`
            );

        } catch (error) {
            console.error(error);
            toast.error('Failed to export chart');
        }
    };

    return (
        <Fragment>
            <Form className='theme-form'>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="category_id">Category</Label>
                                    <select name="category_id" id="category_id" className="form-control"
                                        value={category_id} onChange={handleCategoryChange}>
                                        <option value="">All</option>
                                        {categories.map(category => (
                                            <option key={category._id} value={category._id}>{category.category_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Sub Category</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={subcategory_id} onChange={handleSubCategoryChange}>
                                        <option value="">All</option>
                                        {subcategories.map(subcategory => (
                                            <option key={subcategory._id} value={subcategory._id}>{subcategory.subcategory_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Group</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={group_name} onChange={handleGroupChange}>
                                        <option value="">All</option>
                                        {groups.map((group, index) => (
                                            <option key={index} value={group}>{group}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col>
                                <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
                                    <label>Tenants</label>
                                    <div
                                        onClick={toggleDropdown}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>Select Tenants</div>
                                        <span style={{ marginLeft: 'auto' }}>&#9662;</span>
                                    </div>
                                    {dropdownOpen && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                marginTop: '4px',
                                                zIndex: 1,
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '250px', // Set the maximum height for the dropdown
                                                overflowY: 'auto' // Scrollable content
                                            }}
                                        >
                                            {/* Search Bar */}
                                            <div style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search tenants..."
                                                    value={searchTenant}
                                                    onChange={(e) => setSearchTenant(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered Tenants List */}
                                            {filteredTenants.length > 0 ? (
                                                filteredTenants.map(tenant => (
                                                    <label
                                                        key={tenant._id}
                                                        style={{ display: 'block', padding: '8px', cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={tenant._id}
                                                            checked={selectedTenants.includes(tenant._id)}
                                                            onChange={handleTenantChange}
                                                            style={{ marginRight: '8px' }}
                                                        />

                                                        {/* 👇 Display code + name */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            {tenant.tenant_store_name}
                                                            {tenant.tenant_code ? ` - ${tenant.tenant_code}` : ""}
                                                        </span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: 'gray', textAlign: 'center' }}>
                                                    No results found
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </Col>

                        </Row>
                    </CardBody>
                </Card>
            </Form>
            {loading === true ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>

            ) : (
                <Card>
                    <CardHeader>
                         <Row className="align-items-center">
    {/* Date Filter Buttons */}
    <Col>
                        <Row>
                            {DATE_FILTERS.map(btn => (
                            <Col xs="auto" key={btn.value}>
                                <Button
                                color={activeDateFilter === btn.value ? 'primary' : 'light'}
                                onClick={() => fetchChartData(btn.value)}
                                >
                                {btn.label}
                                </Button>
                            </Col>
                            ))}

                        </Row>
                        </Col>

    {/* Export Button (RIGHT SIDE) */}
    <Col xs="auto" style={{ position: 'relative' }}>
      <Btn
        attrBtn={{
          color: 'primary',
          type: 'button',
          onClick: exportChartToExcel,
          onMouseEnter: () => handleMouseEnter('Export to Excel'),
          onMouseLeave: handleMouseLeave
        }}
      >
        <FontAwesomeIcon icon={faFileExcel} size="lg" />
      </Btn>

      {/* Tooltip */}
      {tooltip === 'Export to Excel' && (
        <div
          style={{
            position: 'absolute',
            top: '-30px',
            right: 0,
            backgroundColor: 'black',
            color: 'white',
            padding: '5px 10px',
            borderRadius: '3px',
            whiteSpace: 'nowrap',
            fontSize: '12px',
            zIndex: 1
          }}
        >
          Export to Excel
        </div>
      )}
    </Col>
                        </Row>
                    </CardHeader>

                    <CardBody>
                        {loading ? <Spinner /> : (
                            <>
       {/* 🔹 Report Header */}
      <Row className="align-items-center mb-3">
        <Col md="6">
          <h5 className="mb-0 fw-semibold">Net Sales Trend</h5>
          <small className="text-muted">
            Period: {startDate} – {endDate}
          </small>
        </Col>

        <Col md="6" className="text-md-end mt-2 mt-md-0">
          <span className="text-muted">Total Net Sales</span>
          <h4 className="mb-0 fw-bold">
            ₹ {totalNetSales.toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </h4>
        </Col>
      </Row>

      <hr className="my-2" />

      {/* 🔹 Line Chart */}
                            <ReactApexChart options={chartOptions} series={chartOptions.series} type="line" height={350} />
                       </>
                     )}
                    </CardBody>
                </Card>
            )}
        </Fragment>
    );
};

export default TimeSeriesTrendChartFromInvoiceView;
